/* eslint-disable react/jsx-indent */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Link from 'modules/Link';

import Icon from 'components/Icon';
import { convertGSToDownloadURL } from 'utils';

const GoBack = ({ match, team }) => {
  const renderAppLogo = useCallback(() => {
    if (
      team &&
      team.isDisabled === false &&
      team.customBranding === true &&
      team.theme?.iconURL
    ) {
      if (team.theme.iconURL.startsWith('gs://')) {
        return (
          <img
            src={convertGSToDownloadURL(team?.theme?.iconURL, false)}
            alt=""
            style={{ width: 20, height: 20, objectFit: 'contain' }}
          />
        );
      }

      return (
        <img
          src={team.theme.iconURL}
          alt=""
          style={{ width: 20, height: 20, objectFit: 'contain' }}
        />
      );
    }

    return (
      <Icon name="icon" width="20px" height="20px" verticalAlign="middle" />
    );
  }, [team]);

  return !match.path.startsWith('/projects') &&
    !match.path.startsWith('/project/:projectID/:pageID') &&
    !match.path.startsWith('/team') ? (
    <Link
      to={
        match.path.startsWith('/project/:projectID') &&
        match.path !== '/project/:projectID'
          ? `/project/${match.params.projectID}`
          : '/projects'
      }
      className="go-back-button tooltip-container"
      style={{ verticalAlign: 'middle' }}>
      {renderAppLogo()}
      <span className="tooltip" style={{ top: -12, left: 15 }}>
        All projects
      </span>
    </Link>
  ) : (
    <></>
  );
};

GoBack.propTypes = {
  match: PropTypes.object.isRequired,
  team: PropTypes.object,
};

export default GoBack;
